import React from 'react'

const PageHeader = ({ title, subtitle, actions, center = false }) => {
  return (
    <div className={`mb-8 flex flex-col gap-4 w-full animate-fade-in ${center ? 'items-center text-center' : 'sm:flex-row sm:items-center sm:justify-between'}`}>
      <div className={`flex flex-col ${center ? 'items-center text-center' : ''}`}>
        <h1 className="text-2xl md:text-3xl font-extrabold text-slate-800 tracking-tight">{title}</h1>
        {subtitle && <div className="text-sm text-slate-500 mt-2 font-medium max-w-2xl">{subtitle}</div>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  )
}

export default PageHeader
